
import 'jquery';
import 'jquery-mask-plugin';

jQuery(function () {

  jQuery(".S3AbrirModal").on("click", function () {
    $("#modalS3").fadeIn();
    return false;
  });

  jQuery("#s3Close").on("click", function () {
    $("#modalS3").fadeOut();
    return false;
  });

  jQuery('.s3_modal_whatsapp_plugin_telefone').mask('(00) 0000-00009');

  
  $("#s3_custom_post_type_lead_form").submit(function (e) {
    e.preventDefault();

    $("#s3_custom_post_type_lead_form button").hide()
    $("#s3_custom_post_type_lead_form .preload").show()

    $.ajax({
      url: js_global.xhr_url,
      type: "POST",
      dataType: 'html',
      data: {
        action: "s3_ajax_leads",
        s3_insert_lead_nonce: js_global.s3_insert_lead_nonce,
        nome: $("#s3_custom_post_type_name").val(),
        whatsapp: $("#s3_custom_post_type_phone").val(),
        email: $("#s3_custom_post_type_email").val(),
        url: $("#s3_custom_post_type_url").val(),
      },
      success: function (response) {
        const obj = JSON.parse(response);
        if (obj.success) {
          $("#s3_custom_post_type_lead_form button").show()
          $("#s3_custom_post_type_lead_form .preload").hide()
          $("#s3_custom_post_type_name").val("")
          $("#s3_custom_post_type_phone").val("")
          $("#s3_custom_post_type_email").val("")
          $("#s3_custom_post_type_url").val("")
          window.open(obj.data.linkRedirecionamento);
        } else {
          console.log("Erro ao cadastrar lead, tente novamente!");
        }
      },
      error: function (xhr, textStatus, error) {
        console.log(xhr.responseText);
        console.log(error)
      },
    });
  });

});